"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortableStateInvokeActionItem = exports.StateInvokeActionItem = exports.StateInvokeActionEditor = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@dnd-kit/core");
const sortable_1 = require("@dnd-kit/sortable");
const utilities_1 = require("@dnd-kit/utilities");
const core_2 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const WorkflowConfigInvokeActionDialog_1 = __importDefault(require("../dialogs/WorkflowConfigInvokeActionDialog"));
const Workflow_context_1 = require("../Workflow.context");
const StyledConfigList = (0, styled_components_1.default)(core_ui_1.ConfigList) `
  margin: 0;
`;
const StyledConfigListItem = (0, styled_components_1.default)(core_ui_1.ConfigListItem) `
  &.dragging {
    opacity: 0.75;
  }
  .list-item-primary {
    white-space: normal;
  }
  .plugin-display {
    padding-left: 22px;
  }
`;
const StateInvokeActionEditor = props => {
    const { shape, taskTypeId, onChange } = props;
    const dragChangeRef = (0, react_1.useRef)({ sourceIndex: -1, targetIndex: -1 });
    const [dragItem, setDragItem] = (0, react_1.useState)();
    const [editAction, setEditAction] = (0, react_1.useState)();
    const sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.PointerSensor));
    const stateNode = shape.data;
    stateNode.invoke = Array.isArray(stateNode.invoke)
        ? stateNode.invoke
        : stateNode.invoke
            ? [stateNode.invoke]
            : [];
    const actions = stateNode.invoke;
    const actionsWithId = (0, core_ui_1.useWithId)(actions);
    const sort = (0, core_ui_1.useSort)(actionsWithId, item => item.id);
    const clearDragChange = () => {
        dragChangeRef.current.sourceIndex = -1;
        dragChangeRef.current.targetIndex = -1;
    };
    return (react_1.default.createElement(core_ui_1.ConfigCard, null,
        react_1.default.createElement(core_ui_1.ConfigHeader, { end: react_1.default.createElement(core_2.IconButton, { size: 'small', onClick: () => setEditAction(null) },
                react_1.default.createElement(icons_1.AddCircleOutline, null)) }, "Actions"),
        react_1.default.createElement(core_1.DndContext, { sensors: sensors, onDragStart: event => {
                // prevent dragging if currently dragging an item
                if (dragItem) {
                    return;
                }
                const index = actionsWithId.findIndex(item => item.id === event.active.id);
                const item = actionsWithId[index];
                dragChangeRef.current.sourceIndex = index;
                setDragItem(item);
            }, onDragOver: event => {
                const { active, over } = event;
                if (over && active.id !== over.id) {
                    dragChangeRef.current.targetIndex = sort.findIndex(over.id);
                    sort.reorder(active.id, over.id);
                }
            }, onDragEnd: () => {
                const { sourceIndex, targetIndex } = dragChangeRef.current;
                // dropped outside the list
                if (sourceIndex > -1 &&
                    targetIndex > -1 &&
                    sourceIndex !== targetIndex) {
                    const [action] = actions.splice(sourceIndex, 1);
                    actions.splice(targetIndex, 0, action);
                    onChange === null || onChange === void 0 ? void 0 : onChange(action);
                }
                clearDragChange();
                setDragItem(undefined);
            }, onDragCancel: () => {
                clearDragChange();
                setDragItem(undefined);
            } },
            react_1.default.createElement(sortable_1.SortableContext, { items: sort.items.map(condition => condition.id) },
                react_1.default.createElement(StyledConfigList, null, sort.items.map((item, index) => (react_1.default.createElement(exports.SortableStateInvokeActionItem, { key: item.id, action: item.item, actionId: item.id, onClick: () => setEditAction(item.item), onRemove: () => {
                        actions.splice(index, 1);
                        onChange === null || onChange === void 0 ? void 0 : onChange(item.item);
                    } }))))),
            react_1.default.createElement(core_1.DragOverlay, null, dragItem && (react_1.default.createElement(exports.StateInvokeActionItem, { isDragging: true, action: dragItem.item, actionId: dragItem.id })))),
        (editAction || editAction === null) && (react_1.default.createElement(WorkflowConfigInvokeActionDialog_1.default, { invoke: editAction, stateNode: stateNode, taskTypeId: taskTypeId, open: !!editAction || editAction === null, onCancel: () => setEditAction(undefined), onChange: action => {
                setEditAction(undefined);
                const index = editAction ? actions.indexOf(editAction) : -1;
                if (index > -1) {
                    actions[index] = action;
                }
                else {
                    actions.push(action);
                }
                onChange === null || onChange === void 0 ? void 0 : onChange(action);
            } }))));
};
exports.StateInvokeActionEditor = StateInvokeActionEditor;
exports.default = exports.StateInvokeActionEditor;
const StateInvokeActionItem = props => {
    const { action, isDragging, listItemProps, dragHandleProps, onClick, onRemove } = props;
    const { servicePlugins } = (0, Workflow_context_1.useWorkflowContext)();
    const plugin = servicePlugins.find(plugin => plugin.src === action.src);
    const classes = [];
    isDragging && classes.push('dragging');
    return (react_1.default.createElement(StyledConfigListItem, Object.assign({}, listItemProps, { hover: true, iconProps: dragHandleProps, className: classes.join(' '), primary: (plugin === null || plugin === void 0 ? void 0 : plugin.name) || action.src, icon: react_1.default.createElement(icons_1.DragIndicator, { color: 'disabled' }), secondaryAction: react_1.default.createElement(core_2.IconButton, { size: 'small', onClick: e => {
                e.stopPropagation();
                onRemove === null || onRemove === void 0 ? void 0 : onRemove();
            } },
            react_1.default.createElement(icons_1.RemoveCircleOutlineOutlined, null)), onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick() }),
        react_1.default.createElement("div", { className: 'plugin-display' }, plugin ? (react_1.default.createElement(plugin.display, { invoke: action })) : (react_1.default.createElement(lab_1.Alert, { severity: 'error' },
            "Invoke Service \"",
            action.src,
            "\" plugin not found.")))));
};
exports.StateInvokeActionItem = StateInvokeActionItem;
const SortableStateInvokeActionItem = props => {
    const { actionId } = props;
    const { attributes, isDragging, listeners, setNodeRef, transform, transition } = (0, sortable_1.useSortable)({ id: actionId });
    return (react_1.default.createElement(exports.StateInvokeActionItem, Object.assign({}, props, { isDragging: isDragging, dragHandleProps: Object.assign(Object.assign({}, attributes), listeners), listItemProps: {
            ref: setNodeRef,
            style: {
                opacity: isDragging ? 0.75 : undefined,
                transform: utilities_1.CSS.Translate.toString(transform),
                transition: transition || undefined
            }
        } })));
};
exports.SortableStateInvokeActionItem = SortableStateInvokeActionItem;
//# sourceMappingURL=StateInvokeActionEditor.js.map